import React from 'react';
import EngineeringOutlined from '@mui/icons-material/EngineeringOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardObrasRecebendoOrcamentos = (props) => {
  const obrasRecebendoOrcamento = useSelector((state) => state.dashboard?.dashboard?.obrasRecebendoOrcamento)

  return (
    <StatCard
      {...props}
      label="Obras recebendo propostas"
      value={obrasRecebendoOrcamento ? obrasRecebendoOrcamento : 0}
      icon={<EngineeringOutlined />}
    />
  );
}

CardObrasRecebendoOrcamentos.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardObrasRecebendoOrcamentos
